import { makeQuery } from '@core/queries';
import { IAdSpend } from '@core/models';

type Output = IAdSpend;

export const getAdSpend = makeQuery<Output>(`
query GetAdSpend {
  getAdSpend {
    totalAmount
    currency
  }
}
`);
